module.exports = __webpack_public_path__ + "static/media/handle-craft.64979bff.png";